import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DashboardLayout } from "@/components/DashboardLayout";
import { adminNav } from "@/config/nav";
import api from "@/lib/api";
import { SkeletonRow } from "@/components/Loaders";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { AdminResetPassword } from "@/components/AdminResetPassword";

export default function AdminUsers() {
  const { user } = useAuth();
  const isSuper = (user?.admin_role || "SUPER") === "SUPER";
  const [role, setRole] = useState("customer");
  const [users, setUsers] = useState(null);

  const load = (r) => { setUsers(null); api.get(`/admin/users?role=${r}`).then((res) => setUsers(res.data)); };
  useEffect(() => { load(role); }, [role]);

  const toggleStatus = async (u) => {
    const next = u.status === "active" ? "inactive" : "active";
    await api.patch(`/admin/users/${u.id}/status`, { status: next });
    toast.success(`Account ${next}`);
    load(role);
  };

  return (
    <DashboardLayout nav={adminNav} title="Admin">
      <h1 className="font-heading text-2xl font-semibold text-stone-900 md:text-3xl">User Management</h1>
      <Tabs value={role} onValueChange={setRole} className="mt-4">
        <TabsList className="rounded-full bg-stone-100">
          <TabsTrigger value="customer" data-testid="users-tab-customer" className="rounded-full">Customers</TabsTrigger>
          <TabsTrigger value="owner" data-testid="users-tab-owner" className="rounded-full">Owners</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-stone-200 bg-white">
        {users === null ? (
          <div className="space-y-2 p-4">{[1, 2, 3].map((i) => <SkeletonRow key={i} />)}</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead><TableHead>Mobile</TableHead><TableHead>Email</TableHead>
                {role === "owner" && <TableHead className="text-center">Properties</TableHead>}
                <TableHead className="text-center">Bookings</TableHead><TableHead className="text-center">Status</TableHead>
                {isSuper && <TableHead className="text-center">Actions</TableHead>}
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((u) => (
                <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                  <TableCell className="font-medium">{u.name}</TableCell>
                  <TableCell>{u.phone}</TableCell>
                  <TableCell className="text-stone-500">{u.email}</TableCell>
                  {role === "owner" && <TableCell className="text-center">{u.property_count}</TableCell>}
                  <TableCell className="text-center">{u.booking_count}</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-center gap-2">
                      <Switch data-testid={`user-toggle-${u.id}`} checked={u.status === "active"} onCheckedChange={() => toggleStatus(u)} />
                      <span className="text-xs capitalize text-stone-500">{u.status}</span>
                    </div>
                  </TableCell>
                  {isSuper && <TableCell className="text-center"><AdminResetPassword userId={u.id} userLabel={u.name || u.email} testid={`user-reset-${u.id}`} /></TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </DashboardLayout>
  );
}
